export const cabecalhos = [
  {
    text: "Descrição do Grupo",
    value: "descricao_grupo"
  },
  {
    text: "Descrição do Segmento",
    value: "descricao_segmento"
  },
  {
    text: "Descrição do Fornecedor",
    value: "descricao_fornecedor"
  },
  {
    text: "Id Produto",
    value: "idproduto"
  },
  {
    text: "Descrição do Produto",
    value: "descricao_produto"
  },
  {
    text: "Estoque em {data_inicial}",
    value: "estoque_em_preco_custo_data_inicial",
    title: "Estoque em preço de custo"
  },
  {
    text: "Estoque em {data_final}",
    value: "estoque_em_preco_custo_data_final",
    title: "Estoque em preço de custo"
  },
  {
    text: "Estoque Ideal em {data_final}",
    value: "estoque_ideal_em_preco_custo_data_final",
    title: "Estoque Ideal em preço de custo"
  },
  {
    text: "Dif. Estoque - Estoque ideal",
    value: "diferenca_em_preco_custo",
    title: "Dif. Estoque em preço de custo - Estoque ideal em preço de custo"
  },
  {
    text: "Status Movimento Estoque",
    value: "descricao_status_movimentacao",
  },
  {
    text: "Total de Crescimento",
    value: "crescimento_em_preco_custo",
    title: "Total de Crescimento em preço de custo"
  },
  {
    text: "Status Produto",
    value: "status_produto",
  },
]
